import React from "react";

import { scrollBy } from "../../../actions/scroll";
import CallToActionButton from "../../layout/CallToActionButton";

import logoBig from "../../layout/assets/logo_big.png";
import logoSmall from "../../layout/assets/logo_small.png";
import resume from "../../layout/assets/CV_Dallas_Hermanson_2023.pdf";
import headerBackground from "./assets/main-section-background.png";

import "./styles/Header.css";

const Header = () => {
  return (
    <div className="header">
      <div className="headerBackgroundLayer" />
      <div
        className="header__container font-lato-regular"
        style={{
          background: `url(${headerBackground})`
        }}
      >
        <div className="header__logo-box">
          <a
            rel="noopener noreferrer"
            href={resume}
            download="CV_Dallas_Hermanson_2023.pdf"
          >
            <img
              srcSet={`${logoSmall} 75w, ${logoBig} 400w`}
              sizes="(max-width: 900px) 8vw, (max-width: 600px) 12vw, (max-width: 400) 20vw"
              alt="Dallas Hermanson Full Stack Developer"
              className="footer__logo"
              src={logoSmall}
            />
          </a>
        </div>
      </div>

      <div className="header__text-container">
        <h1 className="heading-primary font-lato-regular">
          <span className="heading-primary--main">Dallas Hermanson</span>
          <span className="heading-primary--sub">Full Stack Developer</span>
        </h1>
        <CallToActionButton
          handleClick={() => {
            // select id, number of px to add to top of scroll, and delay
            scrollBy("section-portfolio", 170, 500);
          }}
          text="See Portfolio"
          font_colour="#c8b1d5"
        />
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/sections/Section-Header/Header.js